import {Card, FormControlLabel, Stack, Typography} from '@mui/material';
import React from 'react';

import {HighlightedText} from 'presentation/components';
import {formatText} from 'presentation/utils';
import {DistrictCheckboxProps} from './types';
import {StyledCheckbox} from './styles';

export const DistrictCheckbox = ({
	handleSelectCard,
	checked,
	district,
	city,
	query,
	allDistrictsSelected,
	showCityName,
}: DistrictCheckboxProps) => (
	<Card
		elevation={0}
		sx={{
			p: 2,
			cursor: 'pointer',
		}}
		onClick={() => handleSelectCard(`${district}-${city}`)}>
		<Stack direction={'row'}>
			<FormControlLabel
				sx={{alignItems: 'flex-start'}}
				control={<StyledCheckbox sx={{width: 42, marginTop: -1.5}} />}
				checked={allDistrictsSelected || checked}
				slotProps={{
					typography: {
						sx: {
							pl: 1,
						},
					},
				}}
				label={
					<Stack gap={1} onClick={e => e.stopPropagation()}>
						<Typography
							variant="subtitle1"
							fontWeight={600}
							lineHeight={1}
							color="text.primary">
							<HighlightedText text={formatText(district)} highlight={query} />
						</Typography>

						{showCityName ? (
							<Typography variant="body2" color="text.secondary">
								{formatText(city)}
							</Typography>
						) : null}
					</Stack>
				}
			/>
		</Stack>
	</Card>
);
